import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation, Item } from 'baseui/side-navigation';
import { isAuthorized } from '../../shared/auth';
import { ROLE } from '../../config/Role';
import { useTranslation } from 'react-i18next';
import { session } from '../../shared/session';

export interface MenuItem {
    path: string;
    title: string;
    authorizedRoles: Array<ROLE>;
    icon?: React.ReactComponentElement<any>;
    hideInMenu?: boolean;
    children?: MenuItem[]
}

export interface MenuProps {
    routes: Array<MenuItem>;
}

export const Menu = ({ routes }: MenuProps) => {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const ctx = session.data?.token
    const mapMenuItemsToNavigationItems = (menuItems: Array<MenuItem>, parentPath?: string):Array<Item> => {
        return menuItems
            .filter(
                (route) =>
                    isAuthorized(route.authorizedRoles) && !route.hideInMenu,
            )
            .map((route) => ({
                itemId: `#${parentPath || ''}${route.path}`,
                title: t(route.title),
                subNav: route.children ? mapMenuItemsToNavigationItems(route.children, route.path) : undefined
            }));
    }

    const navigationItems: Array<Item> = useMemo(() => {
        return mapMenuItemsToNavigationItems(routes);
    }, [routes, ctx]);

    return <Navigation activeItemId={`#${pathname}`} items={navigationItems} />;
};
